import { render, staticRenderFns } from "./StockDelivery.vue?vue&type=template&id=407f76f8"
import script from "./StockDelivery.vue?vue&type=script&lang=js"
export * from "./StockDelivery.vue?vue&type=script&lang=js"
import style0 from "./StockDelivery.vue?vue&type=style&index=0&id=407f76f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports